import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';
import analytics from 'scripts/lib/analytics';

export default class ToggleExperimentalEditor {
  constructor(context) {
    this.context = context;
  }

  run() {
    const preferences = this.context.stores.agentPreferences.get();
    preferences.toggleExperimentalEditor();

    const params = {
      activeExperimentalEditor: preferences.experimentalEditorEnabled,
    };
    analytics.track('Experimental Text Editor Toggled', params);
    analytics.identifyUserTraits(params);
    setAgentPreferences(this.context, preferences);
  }
}
